import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import { Grid, ListItem, List } from '@material-ui/core';


export default class Rapoarte extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
 
}
    }

     componentDidMount(){
    }

    goToPage= (p) =>{
        this.props.history.push(p)
    }
     render() { 
       return (
          <div>
              <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.rapoarte} />

              <div className='container'>
           
                    <List style={{width:'100%', maxWidth:500, margin:'auto'}}>
                        <ListItem onClick={()=>{this.goToPage('/rapoarteutilizatori')}} style={{justifyContent:'center'}} button>
                            <h3  className='pm-title'>Utilizatori si proiecte</h3>
                        </ListItem>
                        <ListItem onClick={()=>{this.goToPage('/rapoartetimp')}} style={{justifyContent:'center'}} button>
                            <h3  className='pm-title'>Analiza timpului</h3>
                        </ListItem>
                        <ListItem onClick={()=>{this.goToPage('/rapoarateproiecte')}} style={{justifyContent:'center'}} button>
                            <h3  className='pm-title'>Raport comparativ proiecte</h3>
                        </ListItem>
                    </List>

         
              </div>
         </div>
        );
       }
}